import api from "../../infra/api";

class TensaoFornecinemento {
    async Listar() {
        const response = await api({
            method: "GET",
            url: 'api/v1/TensaoFornecimento?page=1&start=0&limit=999&fields=["Id","Descricao","Ativo"]&filter=[{"property":"Ativo","operator":"equal","value":"true","and":false}]'
        })

        return response.data
    }
}

export default new TensaoFornecinemento;